<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" v-model="validForm">

        <v-row>
          <v-col>
            <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name" required
              :rules="[$rules.required]" outlined hide-details="auto"
              @blur="dataset.data.name = (dataset.data.name || '').trim()">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field dense id="registration" label="CPF" v-model="dataset.data.registration" required
              :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto" v-mask="['###.###.###-##']"
              @blur="dataset.data.registration = (dataset.data.registration || '').trim()">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-4">
          <v-col class="d-flex align-center">
            <v-checkbox v-model="dataset.data.is_executor" label="Inventariante" hide-details="auto">
            </v-checkbox>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mt-5 ml-3" small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Selecione esta opção se você for o inventariante do processo.</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-row  v-if="!isExecutor">
          <v-col>
            <v-text-field dense id="federal_registration" label="Número OAB" v-model="dataset.data.federal_registration"
              required :rules="[$rules.required, $rules.alphaNumeric]" outlined hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.statesList" label="OAB UF"
              v-model="dataset.data.federal_registration_uf" item-value="name" item-text="name"
              :rules="[$rules.required]" outlined hide-details="auto">
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field dense id="email" label="E-mail" v-model="dataset.data.email" required
              :rules="[$rules.required]" outlined hide-details="auto"
              @blur="dataset.data.email = (dataset.data.email || '').trim()">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field dense id="address_postal_code" label="CEP" v-model="dataset.data.address_postal_code" required
              :rules="[$rules.required, $rules.cep]" outlined hide-details="auto" v-mask="'##.###-###'"
              @blur="searchCep"></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-text-field dense id="address_street" label="Rua/Avenida" v-model="dataset.data.address_street" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field dense id="address_number" label="Número" v-model="dataset.data.address_number" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-text-field dense id="address_complement" label="Complemento" v-model="dataset.data.address_complement"
              outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field dense id="address_neighborhood" label="Bairro" v-model="dataset.data.address_neighborhood"
              required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field dense id="address_city" label="Cidade" v-model="dataset.data.address_city" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete dense id="address_state" label="Estado" :items="dataset.statesList" item-text="name"
              item-value="sigla" v-model="dataset.data.address_state" required :rules="[$rules.required]" outlined
              hide-details="auto"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field dense label="Telefone" v-model="dataset.data.phone_number" required outlined
              :rules="[$rules.required]" hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field dense outlined label="Senha" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" required
              :rules="[$rules.required, $rules.strongPassword]" :type="showPassword ? 'text' : 'password'"
              v-model="dataset.data.password" @click:append="showPassword = !showPassword" hide-details="auto"
              id="password" @blur="dataset.data.password = (dataset.data.password || '').trim()">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined counter
              required :rules="[$rules.required, $rules.fileSize(4)]" show-size
              hint="O arquivo não pode ser superior a 4MB" hide-details="auto" :label="isExecutor ? 'Documento identificação inventariante' : 'Documento OAB'" :clearable="true"
              @change="onFileSelected($event)" ref="file">
            </v-file-input>

          </v-col>
        </v-row>

        <br>

        <v-row no-gutters class="mb-4">
          <v-col>
            <v-btn-toggle v-model="selectedDocument" mandatory color="primary" class="mb-4" dense>
              <v-btn value="terms" small>Termos de Uso</v-btn>
              <v-btn value="privacy" small>Política de Privacidade</v-btn>
            </v-btn-toggle>

            <div class="mb-4">
              <v-btn small text color="primary" class="mr-2" @click="downloadPdf">
                Baixar {{ selectedDocument === 'terms' ? 'Termos de Uso' : 'Política de Privacidade' }}
              </v-btn>
            </div>

            <div v-if="isMobile">
              <!-- Para celular: usa Google Docs Viewer -->
              <iframe :src="googleDocsViewerUrl" width="100%" height="600px" frameborder="0"
                @error="pdfLoadError = true"></iframe>
            </div>
            <div v-else>
              <!-- Para desktop: usa iframe nativo -->
              <iframe :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'" width="100%" height="400px"
                style="overflow: hidden;" frameborder="0" @error="pdfLoadError = true"></iframe>
            </div>
            <span v-if="pdfLoadError" class="error-text">Erro ao carregar documento de privacidade.</span>

            <br>
            <br>
            <v-checkbox :rules="[$rules.required]" v-model="dataset.data.terms" class="mt-0">
              <template v-slot:label>
                <span>
                  Eu li e concordo com os Termos de Uso e a Política de Privacidade
                </span>
              </template>
            </v-checkbox>
            <span class="important-text">
              * Ao aceitar você estará ciente das práticas de coleta, uso, e divulgação de informações
              pessoais descritas nas políticas mencionadas, e autorizo o processamento dos meus dados
              de acordo com tais termos.
            </span>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-btn color="primary" @click.native="create" :loading="loading">Finalizar</v-btn>
      <v-btn color="grey" text @click.native="goBack">Cancelar</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import statesList from "@/common/data/states-list.data";
import { eventHub } from "@/main";
import axios from "axios";
import string from "@/common/util/string";

export default {
  data: () => ({
    showPassword: false,
    validForm: false,
    loading: false,
    selectedDocument: 'terms',
    pdfLoadError: false,
    termFiles: [],
    dataset: {
      data: {
        address_street: '',
        address_number: '',
        address_complement: '',
        address_neighborhood: '',
        address_city: '',
        address_postal_code: '',
        address_state: null, 
        phone_number: '',
      },
      statesList: statesList,
      terms: false,
    },
  }),

  mounted: function () {
    this.loadTerms();
  },

  computed: {
    pdfUrl() {
      const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);
      return doc ? doc.s3_url : '';
    },

    downloadFileName() {
        const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);
        return this.selectedDocument === 'terms'
            ? `termos_de_uso_v${doc.version || ''}.pdf` 
            : `privacidade_v${doc.version || ''}.pdf`;
    },

    isExecutor () {
      return this.dataset.data.is_executor === true
    }
  },

  googleDocsViewerUrl() {
    if (!this.pdfUrl) {
        return '';
    }
    const encodedUrl = encodeURIComponent(this.pdfUrl);
    const viewerUrl = `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
    return viewerUrl;
  },

  isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },

  methods: {
    // openPdf(pdfPath) {
    //   window.open(`${window.location.origin}${pdfPath}`, "_blank");
    // },


    async create() {

      if (!this.$refs.form.validate()) return;

      if (!this.dataset.data.terms){
        this.$dialog.notify.error("Por favor, leia e aceite nossos Termos de Uso e Política de Privacidade para prosseguir!", {
          position: "top-right",
          timeout: 3000,
        });

        return;
      }

      if (!this.dataset.data.file) {
        this.$dialog.notify.error("Por favor, envie o Documento OAB.", {
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      const proceedAction = await this.$dialog.confirm({
        text: "Deseja finalizar o cadastro?",
        title: "Cadastro",
        actions: {
          false: "Cancelar",
          true: "Finalizar",
        },
      });

      if (!proceedAction) return;

      this.loading = true;
      const payload = this.buildPayload();

      try {
        await axios.post("/api/lawyers/create", payload);

        await this.$dialog.confirm({
          text: "Cadastro realizado com sucesso! Um e-mail foi enviado para a sua caixa de entrada, acesse-o para verificar sua conta.",
          title: "Sucesso",
          actions: {
            true: "OK",
          },
        });

        this.goBack();
      } catch (error) {
        console.error("Erro na requisição:", error);

        const hasResponse = error && error.response && error.response.data;

        if (hasResponse) {

          const apiMessage =
            error.response &&
            error.response.data &&
            error.response.data.content &&
            error.response.data.content.error &&
            error.response.data.content.error.message;

          this.$dialog.notify.error(
            apiMessage || "Erro ao realizar cadastro!",
            {
              position: "top-right",
              timeout: 5000,
            }
          );
        }
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.dataset.data = {};
      eventHub.$emit("DIALOG-REGISTER", false);
    },

    buildPayload() {
      const formData = new FormData();

      formData.append("federal_registration", this.dataset.data.federal_registration);
      formData.append("password", (this.dataset.data.password || '').trim());
      formData.append("terms", this.dataset.data.terms);
      formData.append("name", (this.dataset.data.name || '').trim());
      formData.append("email", (this.dataset.data.email || '').trim());
      formData.append("federal_registration_uf", this.dataset.data.federal_registration_uf);
      formData.append("file", this.dataset.data.file);
      formData.append("registration", (this.dataset.data.registration || '').replace(/\D/g, '').trim());
      formData.append('address_postal_code', (this.dataset.data.address_postal_code || '').replace(/\D/g, '') || '');
      formData.append('address_street', this.dataset.data.address_street);
      formData.append('address_number', this.dataset.data.address_number);
      formData.append('address_complement', this.dataset.data.address_complement || '');
      formData.append('address_neighborhood', this.dataset.data.address_neighborhood);
      formData.append('address_city', this.dataset.data.address_city);
      formData.append('address_state', this.dataset.data.address_state);
      formData.append('phone_number', this.dataset.data.phone_number);
      
      formData.append('is_executor', this.dataset.data.is_executor ? '1' : '0');
      
      formData.append('terms', this.dataset.data.terms);

      const termFile = this.termFiles.find(item => item.document_type === "terms");
      if (termFile && termFile.resource_id) {
          formData.append('resource_id', termFile.resource_id);
      }

      return formData;
    },

    onFileSelected(file) {
      
      this.dataset.data.file = file;
          
    },

    async loadTerms() {

      try {

          const result = await axios.get('/api/terms/updated-lawyer');

          this.termFiles = result.data.content.data

      } catch (error) {
          this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } 

    },

    async downloadPdf() {
      try {

        const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);
        
        if (!doc || !doc.s3_url) {
          throw new Error('Arquivo não encontrado');
        }

        const response = await fetch(doc.s3_url);
        if (!response.ok) {
          throw new Error('Erro ao baixar o arquivo');
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.downloadFileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {   
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      }
    },

    async searchCep() {
      const cep = this.dataset.data.address_postal_code.replace(/\D/g, '')
      if (cep.length !== 8) {
        return
      }

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        const data = response.data

        if (!data.erro) { 
          this.dataset.data.address_street = data.logradouro
          this.dataset.data.address_neighborhood = data.bairro
          this.dataset.data.address_city = data.localidade
          this.dataset.data.address_state = data.uf 
        } else {
          this.dataset.data.address_street = ''
          this.dataset.data.address_neighborhood = ''
          this.dataset.data.address_city = ''
          this.dataset.data.address_state = null
         
        }
      } catch (error) {
        this.dataset.data.address_street = ''
        this.dataset.data.address_neighborhood = ''
        this.dataset.data.address_city = ''
        this.dataset.data.address_state = null
      }
    },

  },
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}

.checkbox-link {
  color: #1976d2;
  text-decoration: none;
}

.checkbox-link:hover {
  text-decoration: underline;
}

.important-text {
  font-size: 12px;
  color: #757575;
}

.error-text {
  color: red;
  font-size: 14px;
}
</style>
